import React from 'react';

import { Building2, LogOut, Mail } from 'lucide-react';
import { Navigate } from 'react-router-dom';

import { useTenant } from '../../contexts/TenantContext';
import { useAuth } from '../../hooks/useAuth';
import LoadingOverlay from '../../components/LoadingOverlay/LoadingOverlay';
import './NoAccess.css';

export const NoAccess: React.FC = () => {
  const { logout } = useAuth();
  const { availableTenants, isLoading } = useTenant();

  // If tenants are still loading, show loading state
  if (isLoading) {
    return <LoadingOverlay />;
  }

  // If tenants have loaded and user has access, redirect to tenant selection
  if (availableTenants.length > 0) {
    return <Navigate to="/select-tenant" replace />;
  }

  const handleLogout = () => {
    logout({ returnTo: window.location.origin });
  };

  return (
    <div className="no-access-container">
      <div className="no-access-card">
        <div className="no-access-content">
          <Building2 className="no-access-icon" />
          <h1>No Tenant Access</h1>
          <p className="subtitle">
            You don't have access to any tenants yet.
          </p>
          <p className="description">
            To get started, you'll need to be invited to a tenant by an
            administrator. Once you receive an invitation, you'll be able to
            access the admin panel.
          </p>

          <div className="help-section">
            <div className="help-item">
              <Mail className="help-icon" />
              <div className="help-text">
                <strong>Need access?</strong>
                <span>
                  Contact your tenant administrator to request access.
                </span>
              </div>
            </div>
          </div>

          <div className="actions">
            <button className="btn-logout" onClick={handleLogout} type="button">
              <LogOut className="btn-icon" />
              Sign Out
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
